import React from 'react';
import './Vision.css';

const Vision = () => {
  return (
    <section id="vision" className="vision">
      <div className="container">
        <div className="vision-content">
          <div className="vision-header">
            <h2 className="section-title">Vision</h2>
          </div>
          <p className="vision-text">
            Powering brand growth through the unstoppable strength of the 6 C's.
          </p>
        </div>
      </div>
    </section>
  );
};

export default Vision;

